module.exports = __webpack_public_path__ + "static/img/fa_banner.75a54fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/fa_banner.png
// module id = a9Ri
// module chunks = 1